var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1105",
    "data-name": "Group 1105",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.428,
    height: 20.156,
    viewBox: "0 0 16.428 20.156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M40.017,17.594H23.589V31.723L31.8,37.751l8.214-6.027V17.594ZM38.151,30.778,31.8,35.436l-6.348-4.658V19.46h12.7V30.778Z",
    transform: "translate(-23.589 -17.594)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M44.33,37.063l-1.211-1.42-4.545,3.878-2.5-1.765L35,39.282l3.685,2.6Z",
    transform: "translate(-31.449 -30.03)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.6853eb13ea6393b4b5790bd82309165b.svg";
export { ForwardRef as ReactComponent };